<template>
  <div
    class="fixed z-40 inset-0 p-8 bg-black/50 flex items-center justify-center"
    @click="$emit('close')"
  >
    <MediaView :fileId="fileId" class="rounded-xl" showControls />
  </div>
  <p
    class="fixed z-50 bottom-4 left-1/2 -translate-x-1/2 bg-white font-bold p-4 rounded-xl cursor-pointer text-center"
    @click="$emit('close')"
  >
    Click anywhere to close.
  </p>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'

import { imageUrl } from '@/utils/constants'

import MediaView from '@/components/MediaView.vue'

export interface ImageModalProps {
  fileId: string
}

defineEmits<{
  (e: 'close'): void
}>()

const props = withDefaults(defineProps<ImageModalProps>(), {})
const fileType = ref<'image' | 'video' | ''>('')

onMounted(async () => {
  try {
    await fetch(`${imageUrl}/${props.fileId}.mp4`, {
      method: 'HEAD',
      mode: 'no-cors'
    })
    fileType.value = 'video'
  } catch (e) {
    fileType.value = 'image'
  }
})
</script>
